import * as i0 from '@angular/core';
import * as i1 from './crnk.operations.module';
import * as i2 from 'ngrx-json-api';
import * as i3 from '@angular/http';
import * as i4 from '@ngrx/store';
import * as i5 from '@ngrx/effects';
export const CrnkOperationsModuleNgFactory:i0.NgModuleFactory<i1.CrnkOperationsModule> = (null as any);
var _decl0_0:i2.DenormaliseStoreResourcePipe = (<any>(null as any));
var _decl0_1:i2.GetDenormalisedValuePipe = (<any>(null as any));
var _decl0_2:i2.SelectStoreResourcePipe = (<any>(null as any));
var _decl0_3:i3.HttpModule = (<any>(null as any));
var _decl0_4:i4.StoreModule = (<any>(null as any));
var _decl0_5:i2.NgrxJsonApiModule = (<any>(null as any));
var _decl0_6:i5.ɵd = (<any>(null as any));
var _decl0_7:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_8:i0.ElementRef = (<any>(null as any));
